import { REACT_APP_CHECKOUT_APP } from 'constants/envs'

export const URL_MERCHANT = `/merchant`
//@deprecated
export const URL_SUPPLIER = `/supplier`
export const URL_DEPRECATED = [{ from: '/buyer', to: '/merchant' }]

export const URL_PUBLIC = '/'
export const URL_GO_TO = '/go-to'
export const URL_BLOCKED_BY_NETWORK = '/blocked-by-network'
export const URL_ERROR = '/error'
export const URL_WELCOME = URL_PUBLIC
export const URL_LOGIN = '/login'
export const URL_LOGIN_BY_EMAIL = '/login-by-email'
export const URL_LOGIN_BY_PHONE = '/login-by-phone'
export const URL_QSA = '/qsa'
export const URL_LOGIN_PHONE_CAMPAING = '/login-phone-campaing'
export const URL_PHONE_EXISTS = '/phone-exists'
export const URL_COMPRATINO = '/compratino'
export const URL_RECOVERY = '/recovery'
export const URL_PASSWORD = '/password'
export const URL_SIGN_UP = '/v2/sign-up'
export const URL_VERIFY_PHONE = '/verify-phone'
export const URL_REGISTER_PHONE = '/register-phone'
export const URL_BIOMETRIC = '/biometric'
export const URL_OWNER_BIOMETRICS = '/owner-biometrics'
export const URL_CHOOSE_IDENTITY_VALIDATION = '/choose-identity-validation'
export const URL_PIX_VALIDATION = '/pix-validation'
export const URL_USER_DATA = '/user-data'
export const URL_PROVE_MEMBERSHIP = '/prove-membership'
export const URL_SEND_MEMBERSHIP_PROOF = '/send-membership-proof'
export const URL_CHOOSE_OWNER = '/choose-owner'
export const URL_SEND_VALIDATION_REQUEST_TO_OWNER = '/send-validation-request-to-owner'
export const URL_EMPTY_QSA_OWNER = '/empty-qsa-owner'
export const URL_USER_COMPANIES = `/user-companies`
export const URL_CREDIT_LOADING = '/credit-loading'
export const URL_EXTENDED_ALERT_LOADING = '/extended-alert-loading'
export const URL_LIMIT_LOADING = '/limit-loading'
export const URL_FEEDBACK = '/feedback'
export const URL_SETTINGS = `/settings`
export const URL_NOTIFICATIONS = `/notifications`
export const URL_HISTORY = `/history`
export const URL_PAYMENT_LINK = `/payment-link`
export const URL_LIMIT_RESERVATION = `/limit-reservation`
export const URL_CONFIRM = '/confirm'
export const URL_DETAIL = `/detail`
export const URL_BILL = `/bill`
export const URL_CANCEL = `/cancel`
export const URL_RAISE_CREDIT_LIMIT = `/raise-credit-limit`
export const URL_HELP = `/help`
export const URL_STATEMENTS = `/statements`
export const URL_PAY = `/pay`
export const URL_PAY_BOLETO = `/pay-boleto`
export const URL_LINE_ITEM_DETAIL = `/preview-line-item`
export const URL_EDIT = `/edit`
export const URL_ONBOARDING = '/onboarding'
export const URL_TERMS = '/terms'
export const URL_REDIRECT = '/redirect'
export const URL_ABOUT = `/about`
export const URL_MENU = `/menu`
export const URL_UPLOAD = `/upload`
export const URL_UPDATE_PASSWORD = `/update-password`
export const URL_CREATE = `/create`
export const URL_HOME = URL_REDIRECT
export const URL_BILL_LIST = `/bills`
export const URL_PAYMENT = `/payment`
export const URL_PAYMENT_PREVIEW = `/preview-item`
export const URL_CSAT = `/csat`
export const URL_SNOOZE_SIMULATE = `/snooze/simulate`
export const URL_SNOOZE_DETAILS = `/snooze/details`
export const URL_SNOOZE_WAITING_PAYMENT = `/snooze/waiting-payment`
export const URL_REQUIRED = `/required`
export const URL_OPT_IN = `/opt-in`
export const URL_BACKGROUND_CHECK = `/bgc`
export const URL_AUTH_CHECK = `/auth`
export const URL_OPT_IN_REQUEST = `/request`
export const URL_ACCEPT = `/accept`
export const URL_REJECT = `/reject`
export const URL_NO_COMPANY = `/no-company`
export const URL_RESEND = '/resend'
export const URL_REVIEW = '/review'
export const URL_STATUS = '/status'
export const URL_APP_STORE_REDIRECT = '/app-store-redirect'
export const URL_CROSS_SELL_LEAD = '/cross-sell-lead'
export const URL_CREDIT_ANALYSIS = '/credit-analysis'

export const URL_QUIZ = `/quiz`

export const URL_INVOICE = `/nota-fiscal`
export const URL_BILLING = `/billing`
export const URL_CANCELED = `/canceled`

export const URL_FAQ = `/faq`
export const URL_PRIVACY_POLICY = `https://tino.com.br/politica-de-privacidade/`
export const URL_USE_TERMS = `https://tino.com.br/termos-de-uso/`
export const URL_MERCHANT_TERMS = `https://www.tino.com.br/termo-de-adesao-estabelecimento-comercial`
export const URL_CONSENT_TERMS = `https://www.tino.com.br/termos-de-consentimento`
export const URL_SITE_TINO = `https://www.tino.com.br/`
export const URL_TINO_APP_ANDROID = `https://play.google.com/store/apps/details?id=com.tinobr.app&hl=pt_BR&pli=1`
export const URL_TINO_APP_IOS = `https://apps.apple.com/br/app/tino-pagamento-a-prazo/id6612035781`
export const URL_SUCCESS = `/success`
export const URL_FINANCING_DEBT = `/financing-debt`

export const URL_INDICATE_SELLER_FORM = `/indicate-seller-form`
export const URL_INDICATE_SELLER_PAGE = 'http://conteudo.tino.com.br/indicacao-lojista'
export const URL_MERCHANT_TOUR = `/merchant-tour`
export const URL_PARTNERS = `/partners`
export const URL_CASHINS = `/cashins`

export const URL_CHECKOUT = `/checkout`
export const URL_CONFIRM_ORDER = `/confirm-order`
export const URL_PAYMENT_SELECTION = `/payment-selection`
export const URL_CASH_PAYMENT = `/cash-payment`
export const URL_PHONE_SELECTION = `/phone-selection`
export const URL_CONFIRM_BEFORE_LEAVE = `/confirm-before-leave`

export const URL_FRUBANA = `https://br.frubana.com/spo/`
export const URL_FREXCO = `https://empresas.frexco.com.br/`
export const URL_ARADO = `https://www.arado.com.br/`

export const URL_RETRIEVE_CONFIG = `${REACT_APP_CHECKOUT_APP}/retrieve-config`

export const URL_SINGLE_PLAYER = `/boleto-avulso`
export const URL_PROVISIONAL_GRADE = `/nota-provisoria`

// URLS Salesperson App
export const URL_SALESPERSON = '/salesperson'
export const URL_MERCHANT_INFO = '/merchant-info'
export const URL_MERCHANT_INSTALLMENTS = '/installments'
export const URL_REGISTER_MERCHANT = '/register-merchant'
export const URL_MY_CLIENTS = '/my-clients'
export const URL_METABASE = 'https://truepay.metabaseapp.com/public/dashboard'

export const URL_QSA_QUESTIONS = '/qsa-questions'
export const URL_ACCOUNT_CREATED = '/account-created'
